<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_location"
        :primary-fields="[ 'name', 'suburb', 'state', 'postcode', 'phone', 'email' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
        @sort="sort = $event; $refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <LocationsTable
          ref="table"
          :account-id="$route.params.accountId"
          :filters="filters"
          :sort="sort"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import LocationsTable from '@/components/Application/Manage/Account/LocationsTable'

export default {
  components: {
    Filters,
    LocationsTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Locations',
        route: { name: 'manage-accounts-account-locations', params: { accountId: this.$route.params.accountId } }
      },
      filters: [],
      sort: {
        field: 'created_at',
        direction: 'desc'
      }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
